import { useState, useEffect } from "react";
import { ShoppingBag, Smartphone } from "lucide-react";
import { SHOP_ALL_URL, APP_STORE_URL, GOOGLE_PLAY_URL } from "@/data/products";

// Fixed bottom action bar shown on mobile only to lift Shop/App conversion.
export const MobileCtaBar = () => {
  const [show, setShow] = useState(false);
  const [appOpen, setAppOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <div
      data-testid="mobile-cta-bar"
      className="fixed inset-x-0 bottom-0 z-[80] lg:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      {appOpen && (
        <div
          data-testid="mobile-cta-app-sheet"
          className="mx-3 mb-2 flex gap-3 rounded-2xl border border-[#1a1f1b]/10 bg-[#12160f] p-3 shadow-2xl"
        >
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-cta-appstore"
            className="flex-1 rounded-xl bg-[#f4f1eb] px-3 py-2.5 text-center text-sm font-semibold text-[#12160f]"
          >
            App Store
          </a>
          <a
            href={GOOGLE_PLAY_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-cta-googleplay"
            className="flex-1 rounded-xl bg-[#f4f1eb] px-3 py-2.5 text-center text-sm font-semibold text-[#12160f]"
          >
            Google Play
          </a>
        </div>
      )}
      <div className="flex items-stretch gap-2.5 border-t border-[#1a1f1b]/10 bg-[#f4f1eb]/95 px-3 py-3 backdrop-blur-xl shadow-[0_-8px_24px_rgba(26,31,27,0.12)]">
        <a
          href={SHOP_ALL_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-cta-shop"
          className="flex flex-[1.4] items-center justify-center gap-2 rounded-full bg-[#e85d04] px-5 py-3 text-sm font-medium text-[#f4f1eb] active:bg-[#b34700]"
        >
          <ShoppingBag size={17} /> Shop All
        </a>
        <button
          onClick={() => setAppOpen((o) => !o)}
          data-testid="mobile-cta-app-toggle"
          className="flex flex-1 items-center justify-center gap-2 rounded-full border border-[#1a1f1b]/25 px-5 py-3 text-sm font-medium text-[#1a1f1b]"
        >
          <Smartphone size={17} /> Get App
        </button>
      </div>
    </div>
  );
};
